var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowerOff = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  "aria-labelledby": titleId,
  width: "1em",
  height: "1em",
  fill: "currentColor"
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 14c0 6.609-5.391 12-12 12S0 20.609 0 14c0-3.797 1.75-7.297 4.797-9.578a1.979 1.979 0 0 1 2.797.391 1.995 1.995 0 0 1-.391 2.797C5.172 9.141 4 11.469 4 14.001c0 4.406 3.594 8 8 8s8-3.594 8-8c0-2.531-1.172-4.859-3.203-6.391a1.995 1.995 0 0 1-.391-2.797 1.981 1.981 0 0 1 2.797-.391A11.877 11.877 0 0 1 24 14zM14 2v10c0 1.094-.906 2-2 2s-2-.906-2-2V2c0-1.094.906-2 2-2s2 .906 2 2z"
})));
export { SvgPowerOff as ReactComponent };
export default __webpack_public_path__ + "assets/images/power-off.svg";